import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';

import $ from 'jquery';
import Telephony from './Telephony';
import OutreachPrograms from './OutreachPrograms';

class TelephonySetting extends Component {

    componentDidMount() {
        (function () {
            var currentPath = window.location.href;
            var path = window.origin + "/platform/projectmgmt/test-and-deploy/DistributionWidget/telephony-setting";
            var path1 = window.origin + "/platform/projectmgmt/test-and-deploy/DistributionWidget/telephony-setting/";
            if (currentPath === path || currentPath === path1) {
                $("#basic-setting").addClass('active');
            } else if (currentPath.includes('/telephony-setting/outreach-programs')) {
                $("#outreach-programs").addClass('active');
            } $("#basic-setting,#outreach-programs")
                .on("click", function () {
                    $("#basic-setting,#outreach-programs")
                        .removeClass('active');
                    localStorage.setItem("last-used-team-settings-sub-tab", $(this)[0].id);
                    $(this).addClass('active')
                })
        })();
    }
    render() {
        return (

            <div id="tabPage" >
                <div className="content" style={{ backgroundColor: "#F9F9FB" }}>
                    <div className="container-fluid" >
                        {/* Nav tabs */}
                        <div className="tab-class" style={{ marginLeft: '10px' }}>
                            <ul className="nav nav-tabs border-bottom navCluster" >
                                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/test-and-deploy/DistributionWidget/telephony-setting" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="basic-setting">
                                        Basic Settings
                                    </li>
                                </Link>
                                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/test-and-deploy/DistributionWidget/telephony-setting/outreach-programs" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="outreach-programs">
                                        Outreach Programs
                                    </li>
                                </Link>

                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route path="/projectmgmt/test-and-deploy/DistributionWidget/telephony-setting/outreach-programs" component={OutreachPrograms}></Route>
                    <Route path="/projectmgmt/test-and-deploy/DistributionWidget/telephony-setting" component={Telephony}></Route>
                </Switch>
            </div>

        );
    }
}
export default TelephonySetting;


// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/TelephonySetting.js